import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ExclamationTriangleIcon, RocketIcon } from "@radix-ui/react-icons";
import { motion, AnimatePresence } from "framer-motion";

type MessageType = "success" | "error";

const AlertMessageType = ({ mtype }: { mtype: MessageType }) => {
  return mtype === "success" ? (
    <RocketIcon className="h-4 w-4" />
  ) : mtype === "error" ? (
    <ExclamationTriangleIcon className="h-4 w-4" />
  ) : null;
};

const InlineAlert = ({
  title,
  message,
  mtype,
}: {
  title: string;
  message: string;
  mtype: MessageType;
}) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="flex-1 space-y-4"
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
      >
        <Alert variant={mtype === "error" ? "destructive" : "default"}>
          <AlertMessageType mtype={mtype} />
          {title && (
            <AlertTitle>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.2, delay: 0.1 }}
              >
                {title}
              </motion.div>
            </AlertTitle>
          )}
          <AlertDescription>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.2, delay: 0.2 }}
            >
              {message}
            </motion.div>
          </AlertDescription>
        </Alert>
      </motion.div>
    </AnimatePresence>
  );
};

export default InlineAlert;
